import { Link } from "react-router-dom";
import { useIntl } from "../lib/i18n";
import LanguageSwitcher from "../components/LanguageSwitcher";

// LandingPage is the unauthenticated entry surface served at `/`. It
// renders the firm's tagline + practice-area cards from i18n so a
// prospect arriving from a search engine has a real first impression
// before being prompted to log in. The four practice areas track the
// demo tenant (Wasatch Immigration Law) — asylum, family, deportation,
// naturalization — and stay in lockstep with the seed copy used for
// the public preview screenshot in the manuals.
const practiceAreas = ["asylum", "family", "deportation", "naturalization"] as const;

export default function LandingPage() {
  const { t } = useIntl();
  return (
    <div className="min-h-full bg-gradient-to-b from-brand-50 to-white">
      <header className="flex items-center justify-between px-8 py-6">
        <span className="text-xl font-semibold text-brand-900">{t("app.title")}</span>
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          <Link
            to="/login"
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          >
            {t("login.submit")}
          </Link>
        </div>
      </header>
      <main className="mx-auto mt-16 max-w-5xl px-8">
        <section className="text-center">
          <h1 className="text-4xl font-semibold text-brand-900">{t("landing.hero.title")}</h1>
          <p className="mx-auto mt-6 max-w-3xl text-lg text-slate-600">
            {t("landing.tagline")}
          </p>
          <Link
            to="/login"
            className="mt-8 inline-block rounded-lg bg-brand-700 px-6 py-3 text-sm font-medium text-white hover:bg-brand-500"
          >
            {t("landing.hero.cta")}
          </Link>
        </section>

        <section className="mt-20">
          <h2 className="text-center text-2xl font-semibold text-brand-900">
            {t("landing.practice.heading")}
          </h2>
          <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {practiceAreas.map((slug) => (
              <article
                key={slug}
                className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition hover:shadow-md"
              >
                <h3 className="text-lg font-semibold text-brand-900">
                  {t(`landing.practice.${slug}.title`)}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {t(`landing.practice.${slug}.desc`)}
                </p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <footer className="mt-20 border-t border-slate-200 py-8 text-center text-xs text-slate-400">
        <span>juris — {t("landing.tagline")}</span>
      </footer>
    </div>
  );
}
